// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductPreview_wrapper__Skiek"};